import req from 'utils/req';
import { z } from 'zod';

const VerificationSchema = z.object({
  id: z.string().uuid(),
  accountId: z.string().uuid(),
  verificationType: z.string(),
  item: z.string(),
  kycCheckProgress: z.string().optional(),
  kycCheckResult: z.string().optional(),
  submittedAt: z.coerce.date().optional(),
  verified: z.boolean(),
  verifiedAt: z.coerce.date().optional(),
});

export type Verification = z.infer<typeof VerificationSchema>;
export const VerificationResponseSchema = z.object({
  accountVerifications: z.array(VerificationSchema),
});

const makePayload = (type: 'email' | 'phone', value: string) => {
  return type === 'email' ? { email: value } : { phoneNumber: value };
};

export async function getVerifications(
  accountId: string,
): Promise<Verification[]> {
  try {
    const response = await req(
      `${URL_API_HOST}/api/v1/account/verifications/${accountId}`,
    ).get();

    const result = VerificationResponseSchema.safeParse(response);

    if (!result.success) {
      return [];
    }

    return result.data.accountVerifications;
  } catch (error) {
    console.error(error);
    return [];
  }
}

export async function sendVerificationCode(
  accountId: string,
  type: 'email' | 'phone',
  value: string,
): Promise<Verification> {
  return await req(
    `${URL_API_HOST}/api/v1/account/${accountId}/verification/${type}`,
  ).post(makePayload(type, value));
}

export async function verifyCode(
  accountId: string,
  verificationId: string,
  code: string,
) {
  return await req(
    `${URL_API_HOST}/api/v1/account/${accountId}/verification/${verificationId}/code`,
  ).post({ code });
}
